import { X } from 'lucide-react';
import { ReactNode } from 'react';
import Modal from '.';
import Button from '../Button';

interface IProps {
  open: boolean;
  onHide: any;
  title: any;
  applyButton?: any;
  applyColor?: string;
  onApply?: any;
  children: ReactNode;
  dialogClassName?: string;
  containerClassName?: string;
  hideFooter?: boolean;
  hideCancelButton?: boolean;
  closeOnBackdropClick?: boolean;
  fullScreen?: boolean;
}

const CommonModal = (props: IProps) => {
  const {
    open,
    onHide,
    title,
    applyButton,
    applyColor = 'bg-blue-600 hover:bg-blue-700',
    onApply = () => {},
    children,
    fullScreen,
    dialogClassName = '',
    containerClassName = '',
    hideFooter = false,
    hideCancelButton = false,
    closeOnBackdropClick = true,
  } = props;

  return (
    <Modal
      show={open}
      onHide={onHide}
      closeOnBackdropClick={closeOnBackdropClick}
      modal-center="true"
      className={
        fullScreen
          ? `fixed inset-0 z-drawer flex items-end justify-center transition-all duration-300 ease-in-out md:items-center md:p-4 ${containerClassName}`
          : `w-screen fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4 ${containerClassName}`
      }
      dialogClassName={
        fullScreen
          ? `flex h-[100dvh] w-full flex-col overflow-hidden bg-white shadow-xl dark:bg-zinc-600 md:h-auto md:max-h-[92vh] md:w-[40rem] md:rounded-2xl ${dialogClassName}`
          : `mx-auto md:w-[40rem] bg-white shadow rounded-xl dark:bg-zink-700 flex flex-col h-full ${dialogClassName}`
      }
    >
      <Modal.Header
        className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-zink-500 bg-blue-50 dark:bg-zink-700"
        closeButtonClass="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500 dark:text-zinc-200 dark:hover:text-red-500"
      >
        <Modal.Title className="text-lg font-bold text-slate-800 flex items-center">
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
        {children}
      </Modal.Body>

      {!hideFooter && (
        <Modal.Footer className="flex items-center justify-between p-4 mt-auto border-t border-slate-200 dark:border-zink-500 bg-slate-50 dark:bg-zink-700">
          {!hideCancelButton && (
            <Button
              className="flex items-center px-4 py-2 rounded-md !text-slate-700 bg-white border border-gray-200 hover:bg-slate-200"
              onClick={onHide}
            >
              <X className="w-4 h-4 mr-1" /> Hủy bỏ
            </Button>
          )}
          <Button
            className={`flex items-center px-4 py-2 rounded-md text-white ${applyColor} ${
              hideCancelButton ? 'ml-auto' : ''
            }`}
            onClick={onApply}
          >
            {applyButton}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default CommonModal;
